import { createIcon } from './icon-utils';

export const WhitePlusIcon = createIcon({
  fill: '#FFFFFF',
  path: 'M7.33594 8.79842H3.33594V7.46509H7.33594V3.46509H8.66927V7.46509H12.6693V8.79842H8.66927V12.7984H7.33594V8.79842Z',
  viewBox: '0 0 16 17',
});
